import {
  Breadcrumb as CXBreadcrumb,
  IBreadcrumbItem as CXIBreadcrumbItem
} from '@sanlamcx/react-ui-next-breadcrumb';

export const Breadcrumb = CXBreadcrumb;
export type IBreadcrumbItem = CXIBreadcrumbItem;
